import { AdvisorAvatar } from '../Common/AdvisorAvatar'

const DOT_COLORS = {
  online:  '#22c55e',  // green-500
  standby: '#eab308',  // yellow-500
  offline: '#6b7280',  // gray-500
}

/**
 * AdvisorStatusDot
 * Wraps AdvisorAvatar and overlays a coloured presence dot bottom-right.
 *
 * Props:
 *   avatarUrl  {string|null}
 *   fullName   {string}
 *   size       {'sm'|'md'|'lg'}
 *   status     {'online'|'standby'|'offline'|null}  null = hide dot
 *   className  {string}
 */
export function AdvisorStatusDot({ avatarUrl, fullName, size = 'md', status = null, className = '', isDarkMode = false }) {
  const dotSize = size === 'lg' ? 14 : size === 'sm' ? 8 : 11
  const offset  = size === 'lg' ? 1  : 0

  return (
    <span className={`relative inline-flex flex-shrink-0 ${className}`}>
      <AdvisorAvatar avatarUrl={avatarUrl} fullName={fullName} size={size} />
      {status && (
        <span
          style={{
            position: 'absolute',
            bottom: offset,
            right: offset,
            width: dotSize,
            height: dotSize,
            borderRadius: '50%',
            background: DOT_COLORS[status] ?? DOT_COLORS.offline,
            border: `2px solid ${isDarkMode ? '#1e293b' : 'white'}`,
          }}
          title={status}
        />
      )}
    </span>
  )
}
